var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch24W(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "19.974px",
    viewBox: "832.441 586.093 20 19.974",
    enableBackground: "new 832.441 586.093 20 19.974",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconos_roca_24x24_expandidos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M852.441,605.367l-6.71-6.689c2.761-3.151,2.445-7.943-0.706-10.704c-3.151-2.761-7.943-2.445-10.704,0.706 c-2.761,3.15-2.445,7.943,0.706,10.704c2.864,2.51,7.146,2.507,10.006-0.007l6.71,6.691L852.441,605.367z M840.056,600.273 c-3.63,0-6.573-2.942-6.574-6.572c0-3.63,2.941-6.573,6.572-6.574c3.63-0.001,6.573,2.941,6.574,6.572c0,0,0,0,0,0.001 C846.624,597.329,843.684,600.269,840.056,600.273z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch24W);
export default __webpack_public_path__ + "static/media/search-24w.1791bd27c1d6701a7882031368d8f76b.svg";
export { ForwardRef as ReactComponent };